import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, GraduationCapIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { PortraitFrame } from '../components/PortraitFrame';
import { certifications, education, pillars } from '../data/site';
export function About() {
  return <>
      <PageHeader eyebrow="About" title="Bridging the gap between clinical reality and commercial success." data-id="element-94" data-mp="2eji0bl9hhxzo" />

      <section className="w-full bg-ivory py-20 lg:py-24" data-id="element-95" data-mp="326gcw7uhglsb">
        <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-96" data-mp="3762qiie8441n">
          <div className="lg:col-span-4" data-id="element-97" data-mp="2s93dug4ill0b">
            <PortraitFrame className="lg:mx-0" data-id="element-98" data-mp="2schcpedyzc30" />
          </div>
          <div className="lg:col-span-8" data-id="element-99" data-mp="2x7wsibvjfi22">
            <h2 className="font-display text-2xl text-ink-950" data-id="element-100" data-mp="1guy3949sqcw0">
              Strategic Value Proposition
            </h2>
            <p className="mt-6 border-l-2 border-brass-500 pl-6 text-lg leading-relaxed text-ink-900" data-id="element-101" data-mp="1lukjlmkx8991">
              From directing emergency medicine operations across major health
              systems to shaping AI-driven decision support and advising venture
              capital portfolios, I help healthcare organizations scale safely,
              strategically, and sustainably.
            </p>

            <div className="mt-12 grid gap-8 sm:grid-cols-3" data-id="element-102" data-mp="1yj3wxffbfqn8">
              {pillars.map((pillar, i) => <motion.article key={pillar.title} initial={{
              opacity: 0,
              y: 14
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-70px'
            }} transition={{
              duration: 0.4,
              delay: i * 0.09
            }} className="border-t-2 border-ink-950 pt-5" data-id="element-103" data-mp="2dfmah7aw2mpi" data-mpi={i}>
                  <h3 className="font-display text-base leading-snug text-ink-950" data-id="element-104" data-mp="2w6m44ltbwkp4">
                    {pillar.title}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-graphite" data-id="element-105" data-mp="2r9lzmfc4nq04">
                    {pillar.body}
                  </p>
                </motion.article>)}
            </div>
          </div>
        </div>
      </section>

      <section className="w-full border-t border-stone bg-white py-20 lg:py-24" data-id="element-106" data-mp="1xvky0p7y8gai">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-107" data-mp="1xthwp91cj0qh">
          <h2 className="font-display text-2xl text-ink-950" data-id="element-108" data-mp="22mt6nj1gfxmm">
            Academic Credentials & Education
          </h2>

          <ul className="mt-10 divide-y divide-stone border-y border-stone" data-id="element-109" data-mp="27n8iu7a02z30">
            {education.map((item, i) => <motion.li key={item.school} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.35,
            delay: i * 0.06
          }} className="flex items-start gap-4 py-6" data-id="element-110" data-mp="2glsvorsvqejb" data-mpi={i}>
                <GraduationCapIcon size={18} className="mt-1 shrink-0 text-brass-500" aria-hidden="true" data-id="element-111" data-mp="r7nu7nbiukpt" />
                <div data-id="element-112" data-mp="ewd681idkj7k">
                  <h3 className="font-display text-base text-ink-950" data-id="element-113" data-mp="ev25ybo51tl7">
                    {item.school}
                  </h3>
                  <p className="mt-1.5 text-sm text-graphite" data-id="element-114" data-mp="9v7eo70gb1zm">
                    {item.credential}
                  </p>
                </div>
              </motion.li>)}
          </ul>

          <h3 className="mt-12 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.24em] text-brass-500" data-id="element-115" data-mp="12k4tg05gegnm">
            <AwardIcon size={14} aria-hidden="true" data-id="element-116" data-mp="snrtikjbf6kf" />
            Board Certifications
          </h3>
          <ul className="mt-5 flex flex-wrap gap-3" data-id="element-117" data-mp="ompzqj863mpu">
            {certifications.map(cert => <li key={cert} className="border border-stone bg-ivory px-4 py-2.5 text-[13px] font-medium text-ink-900" data-id="element-118" data-mp="3des9epm2xm0j">
                {cert}
              </li>)}
          </ul>
        </div>
      </section>
    </>;
}